import { GetEnvironmentReleasePlan } from '@gonfalon/openapi/operations/GetEnvironmentReleasePlan';
import { GetEnvironmentReleasePlans } from '@gonfalon/openapi/operations/GetEnvironmentReleasePlans';

import { createQueryOptions } from '../internal/createQueryOptions';

// fetch a list of environment release plans
export const getEnvironmentReleasePlansQuery = createQueryOptions(GetEnvironmentReleasePlans);

// fetch a single environment release plan by key
export const getEnvironmentReleasePlanQuery = createQueryOptions(GetEnvironmentReleasePlan);
